{
  "common.close": "Đóng",
  "common.athleteFallback": "vận động viên {id}",
  "splash.title": "{app} — Trực quan hóa hoạt động bằng hoạt ảnh",
  "splash.tagline": "Dữ liệu Strava&nbsp;của bạn chuyển động",
  "splash.demo": "Demo",
  "tab.query.title": "Bản đồ của {name}",
  "tab.query.heading": "Truy vấn hoạt động:",
  "tab.query.optDays": "ngày gần đây",
  "tab.query.optActivities": "hoạt động gần đây",
  "tab.query.optIds": "ID hoạt động",
  "tab.query.optDates": "Khoảng ngày",
  "tab.query.idsPlaceholder": "nhập ID hoạt động vào đây",
  "tab.query.after": "Từ:",
  "tab.query.before": "Đến:",
  "tab.query.autozoom": "Tự động thu phóng <i class=\"hf hf-bullseye\"></i> tới kết quả sau khi nhập",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Truy vấn",
  "tab.query.createAccount": "Tạo tài khoản và/hoặc đăng nhập.",
  "tab.query.sports": "Môn thể thao:",
  "tab.query.allSports": "Tất cả môn thể thao",
  "tab.query.sportsExcept": "Tất cả trừ",
  "tab.query.sportsNone": "Không có",
  "tab.query.loadingSports": "Đang tải các môn thể thao…",
  "tab.query.sportsFailed": "Không tải được các môn thể thao của bản đồ này",
  "tab.query.noSports": "Chưa có hoạt động nào",
  "tab.activities.title": "Hoạt động đang hiển thị",
  "tab.activities.clearSelection": "Bỏ chọn",
  "tab.activities.renderSelected": "Hiển thị mục đã chọn",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Thu phóng tới vùng chọn",
  "tab.controls.title": "Cài đặt lớp",
  "tab.controls.timescale": "Thang thời gian <i>&tau;</i>",
  "tab.controls.timescaleHint": "tốc độ phát",
  "tab.controls.period": "Chu kỳ <i>T</i>",
  "tab.controls.periodHint": "hoạt động ~ mô hình",
  "tab.controls.dotSize": "Cỡ chấm",
  "tab.controls.pathWidth": "Độ rộng đường",
  "tab.controls.pathWidthHint": "0 sẽ ẩn các đường",
  "tab.controls.colors": "Màu sắc",
  "tab.controls.colorsHint": "xoay bảng màu",
  "tab.controls.shadows": "Bóng đổ",
  "tab.profile.loginTitle": "Đăng nhập",
  "tab.profile.anonNote": "Đăng nhập bằng Strava để xem hoạt động của bạn và quản lý tài khoản Heatflask.",
  "tab.profile.loginLink": "Đăng nhập bằng Strava",
  "tab.profile.editOnStrava": "Sửa hồ sơ trên Strava",
  "tab.profile.indexNote": "Chúng tôi lập chỉ mục tóm tắt hoạt động của bạn để truy cập nhanh.",
  "tab.profile.viewIndex": "Xem chỉ mục",
  "tab.profile.sharedMaps": "Chia sẻ bản đồ",
  "tab.profile.sharedMapsNote": "Tắt: chỉ bạn thấy hoạt động của mình trên Heatflask. Bật: bất kỳ ai có liên kết tới bản đồ của bạn đều thấy những hoạt động bạn đã để công khai trên Strava. Hoạt động riêng tư luôn chỉ mình bạn thấy. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Cách bảo vệ quyền riêng tư</a>",
  "tab.profile.logout": "Đăng xuất",
  "tab.profile.deleteAccount": "Xóa tài khoản",
  "tab.profile.deleteConfirm": "Xóa tài khoản Heatflask của bạn?\n\nThao tác này sẽ xóa các hoạt động đã lập chỉ mục và thu hồi quyền truy cập của Heatflask vào dữ liệu Strava của bạn. Không thể hoàn tác.",
  "tab.profile.languageHeading": "Ngôn ngữ",
  "tab.profile.languageAuto": "Tự động",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Giúp chúng tôi sửa bản dịch hoặc thêm ngôn ngữ mới!</a>",
  "tab.profile.unitsHeading": "Đơn vị",
  "tab.profile.unitsAuto": "Tự động",
  "tab.profile.unitsMetric": "Hệ mét (km, m)",
  "tab.profile.unitsImperial": "Hệ Anh (mi, ft)",
  "tab.profile.textSizeHeading": "Cỡ chữ",
  "tab.profile.textSmaller": "Nhỏ hơn",
  "tab.profile.textReset": "Bình thường",
  "tab.profile.textLarger": "Lớn hơn",
  "tab.profile.mapDefaultsHeading": "Mặc định bản đồ",
  "tab.profile.mapDefaultsNote": "Bắt đầu với bản đồ nền, địa hình và cài đặt lớp này mỗi khi bạn mở một bản đồ mà liên kết không tự đặt. Liên kết bạn chia sẻ vẫn hiển thị đúng những gì bạn thấy.",
  "tab.profile.mapDefaultsSave": "Lưu làm mặc định của tôi",
  "tab.profile.mapDefaultsForget": "Quên",
  "tab.info.title": "Thông tin",
  "tab.info.controlsHeading": "Điều khiển",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + kéo",
  "tab.info.shiftDragDesc": "Chọn các hoạt động trong một khung. Trên màn hình cảm ứng, chạm vào <i class=\"hf-object-group\"></i> trước, rồi kéo bằng một ngón tay. Hoạt động được chọn sau cùng sẽ hiện chi tiết, và danh sách hoạt động cuộn tới đó.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + kéo",
  "tab.info.ctrlDragDesc": "Xoay và nghiêng bản đồ 3D, hoặc dùng hai ngón tay",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Mở hoặc đóng thanh bên",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Thẻ trước hoặc thẻ sau",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Đóng thanh bên",
  "tab.info.liveUrlHeading": "URL trực tiếp",
  "tab.info.liveUrlDesc": "Khung nhìn bản đồ và cài đặt hoạt ảnh được lưu trong URL của trang, nên ai bạn chia sẻ cũng sẽ thấy đúng khung nhìn đó.",
  "tab.info.videoHeading": "Xuất video",
  "tab.info.videoDesc": "Nút <i class=\"hf-video-camera\"></i> ghi hoạt ảnh thành MP4: chạm vào nút, đặt khung lên phần bản đồ bạn muốn, rồi chạm lần nữa để ghi. Video ghi trọn một vòng hoạt ảnh nên sẽ lặp lại liền mạch; vòng nào dài hơn {max} giây (độ dài video tối đa Strava chấp nhận) sẽ bị cắt ở giây thứ {max}.",
  "tab.info.contributeHeading": "Đóng góp",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Tài trợ trên GitHub",
  "tab.info.contactsHeading": "Liên hệ",
  "map.basemapAndTerrain": "Bản đồ nền và địa hình",
  "map.pauseAnimation": "Tạm dừng hoạt ảnh",
  "map.resumeAnimation": "Tiếp tục hoạt ảnh",
  "capture.record": "Quay video (vòng lặp {period} giây)",
  "capture.recordTruncated": "Quay video (một chu kỳ dài {period} giây; chỉ ghi {max} giây đầu)",
  "capture.recordArea": "Ghi vùng bên trong khung",
  "capture.stop": "Dừng ghi",
  "capture.selectionTooSmall": "vùng chọn quá nhỏ",
  "capture.saved": "đã lưu {name} ({size})",
  "capture.cancelled": "đã hủy ghi",
  "capture.failed": "ghi thất bại: {error}",
  "capture.loadingEncoder": "đang tải bộ mã hóa…",
  "capture.waitingForMap": "đang chờ bản đồ tải…",
  "capture.encoding": "đang mã hóa… {percent}%",
  "capture.finalizing": "đang hoàn tất…",
  "share.title": "Chia sẻ liên kết đến bản đồ này",
  "share.copied": "đã sao chép liên kết",
  "share.copiedUnshared": "đã sao chép liên kết — nhưng bản đồ của bạn chưa được chia sẻ nên người khác không mở được. Bật “Chia sẻ bản đồ” để thay đổi.",
  "share.unshared": "Bản đồ của bạn chưa được chia sẻ nên người khác không mở được liên kết này. Bật “Chia sẻ bản đồ” để thay đổi.",
  "share.copyThis": "Sao chép liên kết này:",
  "update.available": "Đã có phiên bản Heatflask mới.",
  "update.reload": "Tải lại",
  "import.title": "Đang nhập",
  "import.stop": "Dừng",
  "import.stopping": "đang dừng…",
  "import.contacting": "đang kết nối Strava…",
  "import.countOf": "{received} / {total} hoạt động",
  "import.count": "{received} hoạt động",
  "import.waitStrava": "Tạm dừng đến {time} do giới hạn tải xuống của Strava. Hãy để trang này mở; tải lại không làm nhanh hơn.",
  "import.waitRationed": "Bạn đã dùng hết lượt tải nhanh hôm nay. Phần còn lại tiếp tục lúc {time}, chậm hơn. Hãy để trang này mở.",
  "import.dailyLimit": "Đã hết giới hạn tải xuống hằng ngày của Strava. Hãy thử lại sau {time}.",
  "import.dailyRationed": "Bạn đã dùng hết phần tải xuống từ Strava hôm nay. Hãy thử lại sau {time}.",
  "import.noActivitiesYet": "Tài khoản Strava của bạn chưa có hoạt động nào. Hãy ghi lại hoặc tải lên một hoạt động trên Strava, nó sẽ hiện ở đây.",
  "table.noActivities": "không có hoạt động",
  "table.untitled": "(không có tiêu đề)",
  "activities.pageTitle": "{app} — Chỉ mục hoạt động",
  "activities.heading": "Chỉ mục hoạt động",
  "activities.fetching": "Đang tải hoạt động...",
  "activities.rateLimit": "Đã chạm giới hạn truy vấn của Strava; sẽ tiếp tục lúc {time}",
  "activities.noData": "Rất tiếc, không có dữ liệu &#128577;",
  "activities.colServerCache": "Lộ trình được lưu đệm trên máy chủ (Mongo)",
  "activities.colBrowserCache": "Lộ trình được lưu đệm trong trình duyệt này",
  "activities.cachedServer": "Lộ trình của {id} đã được lưu đệm trên máy chủ",
  "activities.notCachedServer": "Lộ trình của {id} chưa được lưu đệm trên máy chủ",
  "activities.cachedBrowser": "Lộ trình của {id} đã được lưu đệm trong trình duyệt này",
  "activities.notCachedBrowser": "Lộ trình của {id} chưa được lưu đệm trong trình duyệt này",
  "sport.AlpineSki": "Trượt tuyết đổ dốc",
  "sport.BackcountrySki": "Trượt tuyết đường dài",
  "sport.Badminton": "Cầu lông",
  "sport.Basketball": "Bóng rổ",
  "sport.Canoeing": "Chèo xuồng",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Khiêu vũ",
  "sport.EBikeRide": "Đạp xe điện",
  "sport.Elliptical": "Máy tập elip",
  "sport.EMountainBikeRide": "Đạp xe địa hình điện",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Đạp xe gravel",
  "sport.Handcycle": "Xe đạp tay",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Leo núi đi bộ",
  "sport.IceSkate": "Trượt băng",
  "sport.InlineSkate": "Trượt patin",
  "sport.Kayaking": "Chèo thuyền kayak",
  "sport.Kitesurf": "Lướt ván diều",
  "sport.MountainBikeRide": "Đạp xe địa hình",
  "sport.NordicSki": "Trượt tuyết băng đồng",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Vật lý trị liệu",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Đạp xe",
  "sport.RockClimbing": "Leo núi đá",
  "sport.RollerSki": "Trượt tuyết bánh lăn",
  "sport.Rowing": "Chèo thuyền",
  "sport.Run": "Chạy bộ",
  "sport.Sail": "Chèo buồm",
  "sport.Skateboard": "Trượt ván",
  "sport.Snowboard": "Trượt tuyết ván",
  "sport.Snowshoe": "Đi giày tuyết",
  "sport.Soccer": "Bóng đá",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Máy leo cầu thang",
  "sport.StandUpPaddling": "Chèo SUP",
  "sport.Surfing": "Lướt sóng",
  "sport.Swim": "Bơi",
  "sport.TableTennis": "Bóng bàn",
  "sport.Tennis": "Quần vợt",
  "sport.TrailRun": "Chạy địa hình",
  "sport.Velomobile": "Xe đạp nằm có vỏ",
  "sport.VirtualRide": "Đạp xe ảo",
  "sport.VirtualRow": "Chèo thuyền ảo",
  "sport.VirtualRun": "Chạy bộ ảo",
  "sport.Volleyball": "Bóng chuyền",
  "sport.Walk": "Đi bộ",
  "sport.WeightTraining": "Tập tạ",
  "sport.Wheelchair": "Xe lăn",
  "sport.Windsurf": "Lướt ván buồm",
  "sport.Workout": "Tập luyện",
  "sport.Yoga": "Yoga"
}
